import * as React from 'react'

import PopularLargeIcon from '../../icons/homePage/popularLarge'
import SupportLargeIcon from '../../icons/homePage/supportLarge'
import QualityLargeIcon from '../../icons/homePage/qualityLarge'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import {
  IHomePageBlockComponent,
  ISearchCta
} from '../../../../typings/pageBlocks'
import SafeInnerHtml from '../../safeInnerHtml'
import { getWindow } from '../../../../common/utils/window'
import SearchLink from '../../../containers/searchLinkContainer'
import Button from '../../button'

import * as styles from './aspirationalValuePropositionBlock.module.css'

interface ITiles {
  title: string
  description: string
  icon: string
}

interface IProps extends IHomePageBlockComponent {
  title: string
  tiles: ITiles[]
  cta: ISearchCta
}

const icons = new Map([
  ['popularLarge', PopularLargeIcon],
  ['supportLarge', SupportLargeIcon],
  ['qualityLarge', QualityLargeIcon]
])

const reportAspirationalValuePropositionBlockClick = (eventLabel: string) => {
  reportBlockClick('Aspirational Value Proposition', {
    dimension19: 'body',
    eventLabel
  })
}

const AspirationalValuePropositionBlock = ({ title, tiles, cta }: IProps) => {
  return (
    <section className={styles.root}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          <SafeInnerHtml html={title} />
        </h2>
      </header>
      <div className={styles.tilesArea}>
        {tiles.map((tile, index) => {
          const Icon = icons.get(tile.icon)
          return (
            <div className={styles.tile} key={index}>
              {Icon && (
                <div className={styles.tileIconArea}>
                  <Icon className={styles.tileIcon} />
                </div>
              )}
              <div className={styles.tileDescription}>{tile.description}</div>
            </div>
          )
        })}
      </div>
      <footer className={styles.footer}>
        <Button
          large
          type={Button.Type.Primary}
          fixedWidth
          locationParams={cta.urlSearchParams}
          renderAs={SearchLink}
          onClick={() => {
            reportAspirationalValuePropositionBlockClick(cta.title)
            getWindow().scrollTo(0, 0)
          }}
        >
          {cta.title}
        </Button>
      </footer>
    </section>
  )
}

export default AspirationalValuePropositionBlock
